import { useEffect, useState } from "react";
import FirstBannerSection from "./FirstBannerSection";
import Services from "./Services";
import Brand from "./Brand";
import Insurance from "./Insurance";
import VideoCarousel from "./VideoCarousel";
import Blogs from "./Blogs";
import Testimonials from "./Testimonials";
import WhyUs from "../../utility/serviceTemplateutility/WhyUs";
import { useGlobalData } from "../../contextApi/globalContextData";
import SpinWheel from "../../utility/SpinWheel";
import { motion } from "framer-motion";
import { useLanguage } from "../../contextApi/languageContext";
import OurTeamHome from "./OurTeamHome";
import InstagramFeed from "../../utility/serviceTemplateutility/InstagramFeed";

const Homepage = () => {
  const { sectionsData, loading, error } = useGlobalData();
  const [showSpinWheel, setShowSpinWheel] = useState(false);
  const { language } = useLanguage();

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSpinWheel(true);
    }, 10000); // 10 seconds

    return () => clearTimeout(timer);
  }, []);

  const uuid = localStorage.getItem("spin_uuid");

  // useEffect(() => {
  //   const fetchUserDetails = async () => {
  //     try {
  //       const res = await axios.get(`${API_URL}/user/${uuid}`);
  //       if (res.data.success) {
  //         console.log("✅ User details:", res.data.user);
  //       } else {
  //         console.warn("⚠️ User not found");
  //       }
  //     } catch (err) {
  //       console.error("❌ Failed to fetch user:", err);
  //     }
  //   };

  //   if (uuid) {
  //     fetchUserDetails();
  //   }
  // }, [uuid]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error loading data.</p>;

  return (
    <>
      <VideoCarousel language={language} />
      {sectionsData["Banner"] && (
        <FirstBannerSection data={sectionsData["Banner"]} language={language} />
      )}

      <Services />

      <WhyUs language={language} />
      <div className="text-center" style={{ marginTop: "3rem" }}>
        {language === "ar" ? (
          <h3
            className="fw-bold fade-in"
            style={{ color: "#c69933", fontSize: "3rem" }}
          >
            تعرف على أطبائنا المتخصصين
          </h3>
        ) : (
          <h3
            className="fw-bold fade-in"
            style={{ color: "#c69933", fontSize: "3rem" }}
          >
            Meet Our Specialists
          </h3>
        )}
      </div>
      {sectionsData["Professional"] && (
        <OurTeamHome data={sectionsData["Professional"]} />
      )}

      {sectionsData["Success Stories"] && (
        <Testimonials
          data={sectionsData["Success Stories"]}
          language={language}
        />
      )}
      <Blogs language={language} />
      {sectionsData["Brands"] && (
        <Brand data={sectionsData["Brands"]} language={language} />
      )}
      {sectionsData["Insurance"] && (
        <Insurance data={sectionsData["Insurance"]} language={language} />
      )}

      <InstagramFeed />

      {showSpinWheel && (
        <motion.div
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          <SpinWheel />
        </motion.div>
      )}
    </>
  );
};

export default Homepage;
